/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import classnames from 'classnames';
import { getRichTextHtml } from '@msdyn365-commerce/core';
import ReCAPTCHA from 'react-google-recaptcha';
import * as MsDyn365 from '@msdyn365-commerce/core';
import { Button, IModuleProps, INodeProps } from '@msdyn365-commerce-modules/utilities';
import { Image, IImageSettings } from '@msdyn365-commerce/core';
import { computed } from 'mobx';
import { ICittaPopUpCopyData } from './citta-pop-up-copy.data';
import { ICittaPopUpCopyProps } from './citta-pop-up-copy.props.autogenerated';
import { GetCookie, SetCookie } from '../../shared-utils/cookie-utilities';
export interface ICittaPopUpCopyState {
    cookieValue?: string;
    // firstName: string;
    // lastName: string;
    emailAddress: string;
    eAValError: boolean;
    eAError: boolean;
    fNError: boolean;
    lNError: boolean;
    rCCError: boolean;
    reqError: boolean;
    responseError: boolean;
    responseSuccess: boolean;
    responseReceived: boolean;
    showResponseSuccess: boolean;
    reCaptchaChecked: boolean;
    // firstNameErrorClass: string;
    // lastNameErrorClass: string;
    emailErrorClass: string;
}

export interface ICittaPopUpCopyForm {
    FormWrapper: INodeProps;
    FormContainer: INodeProps;
    // firstAndLastNameInput: React.ReactNode;
    emailInput: React.ReactNode;
    reCaptcha: React.ReactNode;
    subscribeButtton: React.ReactNode;
    subscribeThanks: React.ReactNode;
}
export interface ICittaPopUpCopyViewProps extends ICittaPopUpCopyProps<ICittaPopUpCopyData> {
    message: String;
    image: Image;
    cookieValue: string;
    closeButton: INodeProps
    MessageTextProps: INodeProps;
    ImageTextProps: INodeProps;
    isMobile: boolean;
    SubscribeWrapper: IModuleProps;
    subscribeForm:ICittaPopUpCopyForm;
    subscribeResponse: React.ReactNode;
    responseSuccess: boolean;
    showResponseSuccess: boolean;
    formErrors: React.ReactNode;
    formErrorsNodeProps: INodeProps;
    successResponse: React.ReactNode;
    showSuccessResponse: boolean;
    successResponseNodeProps: INodeProps;
}

export type GridSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl';

/**
 *
 * CittaPopUpCopy component
 * @extends {React.PureComponent<ICittaPopUpCopyProps<ICittaPopUpCopyData>>}
 */
class CittaPopUpCopy extends React.PureComponent<ICittaPopUpCopyProps<ICittaPopUpCopyData>, ICittaPopUpCopyState> {
    // private _FirstNameInputRef: React.RefObject<HTMLInputElement>;
    // private _LastNameInputRef: React.RefObject<HTMLInputElement>;
    private _EmailAddressInputRef: React.RefObject<HTMLInputElement>;
    private _recaptchaRef: React.RefObject<ReCAPTCHA>;

    // private firstNameValue: boolean = false;
    // private lastNameValue: boolean = false;
    private emailAddressValue: boolean = false;
    private formInputValues: boolean = false;
    private responseMessage: string | undefined;
    private moduleClassName: string = 'newsletterSubWrap';
    private recaptchaErrorMessage: string | undefined;


    @computed get isMobile(): boolean {
        return (this._viewport === 'xs' || this._viewport === 'sm');
    }
    private _viewport: GridSize;
    private _internationalCookieName: string = 'cittainternational';
    private _timer: any;

    constructor(props: ICittaPopUpCopyProps<ICittaPopUpCopyData>) {
        super(props);
        // this._FirstNameInputRef = React.createRef();
        // this._LastNameInputRef = React.createRef();
        this._EmailAddressInputRef = React.createRef();
        this._recaptchaRef = React.createRef();
        const cookieValue = GetCookie(props.context.request.cookies, this._internationalCookieName);
        this._viewport = props.context.request && props.context.request.device && props.context.request.device.Type === 'Mobile' ? 'xs' : 'lg';
        this._handleSubmit = this._handleSubmit.bind(this);

        this.state = {
            cookieValue,
            // firstName: '',
            // lastName: '',
            emailAddress: '',
            fNError: false,
            lNError: false,
            eAError: false,
            eAValError: false,
            rCCError: false,
            reqError: false,
            responseReceived: false,
            responseError: false,
            reCaptchaChecked: false,
            responseSuccess: false,
            showResponseSuccess: false,
            // firstNameErrorClass: 'hide',
            // lastNameErrorClass: 'hide',
            emailErrorClass: 'hide',
        };
        
        this._updateViewport = this._updateViewport.bind(this);
    }

    public componentDidMount(): void {
        if (MsDyn365.msdyn365Commerce.isBrowser && window.addEventListener) {
            window.addEventListener('resize', this._updateViewport);
            this._updateViewport();
        }
    }

    public componentWillUnmount(): void {
        if (MsDyn365.msdyn365Commerce.isBrowser && window.removeEventListener) {
            window.removeEventListener('resize', this._updateViewport);
        }
    }

    public render(): JSX.Element | null {
        const {
            context
        } = this.props;
        const isConsentGiven = context && context.request && context.request.cookies && context.request.cookies.isConsentGiven();

        if (this.state.cookieValue !== 'HIDE') {
            this.checkCookie();
        }

        if (this.state.cookieValue === 'HIDE' || !isConsentGiven) {
            this.stopTimer();
            return null;
        }

        const viewprops = {
            ...this.props,
            image: this._renderImage(),
            message: this._renderMessage(),
            closeButton: this._renderCloseLink(),
            SubscribeWrapper: {
                moduleProps: this.props,
                className: classnames(this.moduleClassName, this.props.config.className)
            },

            isMobile: this.isMobile,
            MessageTextProps: { className: 'ms-message__content' },
            ImageTextProps: { className: 'ms-image__content' },
            cookieValue: this.state.cookieValue,
            subscribeResponse: this._getSubmitResponse(),
            subscribeForm: this._renderForm(),
            responseSuccess: this.state.responseSuccess,
            showResponseSuccess: this.state.showResponseSuccess,
            formErrors: this._renderErrors(),
            formErrorsNodeProps: {
                className: 'competition-form-errors'
            },
            successResponse: this._renderSuccessResponse(),
            showSuccessResponse: this.state.responseSuccess,
            successResponseNodeProps: {
                className: 'competition-form-success'
            }
        };

        return this.props.renderView(viewprops) as React.ReactElement;
    }

    private _renderImage(): React.ReactNode {
        const gridSettings = this.props.context.request.gridSettings;

        let defaultImageSettings: IImageSettings = {
            viewports: {
                xs: { q: `w=480&h=680&m=6`, w: 0, h: 0 },
                lg: { q: `w=480&h=680&m=6`, w: 0, h: 0 },
                xl: { q: `w=480&h=680&m=6`, w: 0, h: 0 }
            },
            lazyload: true
          };

        let image = this.props.config.desktopImage;
        // if (this.isMobile) {
        //     image = this.props.config.mobileImage;
        //     defaultImageSettings = {
        //         viewports: {
        //             xs: { q: `w=680&h=480&m=6`, w: 0, h: 0 },
        //             lg: { q: `w=680&h=480&m=6`, w: 0, h: 0 },
        //         },
        //         lazyload: true
        //       };
        // } 

        return (
            <div className='popup-image'>
                {this.isMobile? null :
                 <Image
                    className={'popup-image__image'}
                    altText={'citta'}
                    {...image}
                    gridSettings={gridSettings!}
                    imageSettings={defaultImageSettings}
                    loadFailureBehavior='empty'
                />}
            </div>
        );
    }
    private _getSubmitResponse(): React.ReactNode {
        return (
            this.state.responseReceived && this.responseMessage !== '' || undefined
                ? (
                    <div className={`response-message ${this.state.responseError ? 'response-error' : ''}`}>
                        <p className='response-message-content'>{this.responseMessage}</p>
                    </div>
                )
                : null
        );
    }
 
    private _renderSuccessResponse(): React.ReactNode {
        return (
            this.state.responseSuccess
                ? (
                    <div className="response-succcess">
                        <h2>{this.props.config.successTextResponse}</h2>
                    </div>
                )
                : null
        );
    }

    private _renderForm(): ICittaPopUpCopyForm {
        return {
            FormWrapper: {
                className: 'competition-form',
            },
            FormContainer: {
                className: 'competition-form-div',
            },
            // firstAndLastNameInput: this._renderFirstAndLastNameInput(),
            emailInput: this._renderEmailInput(),
            subscribeButtton: this._renderSubmitButton(),
            subscribeThanks: this._renderSubmitThanks(),
            reCaptcha: this._renderReCaptcha(),
        };
    }

    // private _renderFirstAndLastNameInput(): React.ReactNode {
    //     return (
    //         <div className='name-input-container'>
    //             <div className='name-input'>
    //                 <input
    //                     ref={this._FirstNameInputRef}
    //                     type='text'
    //                     onChange={this._handleChange('firstName')}
    //                     aria-label='First Name'
    //                     className='first-name-input-text'
    //                     placeholder={this.props.config.firstNamePlaceholderText ||"First Name"}
    //                     value={this.state.firstName}
    //                     required
    //                 />
    //             </div>
    //             <div className='name-input'>
    //                 <input
    //                     ref={this._LastNameInputRef}
    //                     type='text'
    //                     onChange={this._handleChange('lastName')}
    //                     aria-label='Last Name'
    //                     className='last-name-input-text'
    //                     placeholder={this.props.config.lastNamePlaceholderText ||"Last Name"}
    //                     value={this.state.lastName}
    //                     required
    //                 />
    //             </div>
    //         </div>
    //     );
    // }

    private _renderEmailInput(): React.ReactNode {
        return (
            <div className='email-address-input'>
                {this.state.eAError || this.state.eAValError ? this._renderAlert('email-address-input') : ''}
                <input
                    ref={this._EmailAddressInputRef}
                    type='email'
                    onChange={this._handleChange('emailAddress')}
                    aria-label='Email Address'
                    className='email-address-input-text'
                    value={this.state.emailAddress}
                    required
                    placeholder={this.props.config.emailInputPlaceholder ||"Email Address"}
                />
            </div>
        );
    }


    private _renderAlert(className: string): JSX.Element {
        return <></>;
    }

    private _renderRecaptchaAlert(className: string): JSX.Element {

        if (this.props.config.reCaptchaOption) {
            if (!this.state.reCaptchaChecked) {
                this.recaptchaErrorMessage = this.props.resources.recaptchaErrorMessage;
            }
        }

        const rCCError = this.state.rCCError;
        return (
            <>
                {rCCError && (
                    <span className={`${className}__alert`} role='alert' aria-live='assertive'>
                        {
                            this.recaptchaErrorMessage &&
                            <>
                                <span className={`${className}__alert-icon`} aria-hidden='true' />
                                {this.recaptchaErrorMessage}
                            </>
                        }
                    </span>
                )}
            </>
        );
    }

    private _renderReCaptcha(): React.ReactNode {
        return (
            <div>
                <div className=''>
                    {this.state.rCCError ? this._renderRecaptchaAlert('recaptcha-error') : ''}
                    <ReCAPTCHA
                        ref={this._recaptchaRef}
                        sitekey={this.props.config.reCaptchaSiteKey!}
                        size="invisible"
                        onChange={() => this._submit()}
                    />
                </div>
            </div>
        );
    }

    private _renderSubmitButton(): React.ReactNode {
        return (
            <div className="subscribe-button-container">
                <Button
                    className={`subscribe-button btn-thirdary`}
                    title={this.props.config.submitButtonLabel}
                    color='primary'
                    onClick={this._handleSubmit}
                >{this.props.config.submitButtonLabel || 'subscribe'}
                </Button>
            </div>
        );
    }

    private _renderSubmitThanks(): React.ReactNode {
        return (
            <div>
                <div className={`subscribe-thanks`}>
                    Thanks!
                </div>
            </div>
        );
    }

    private _showErrors = (): void => {
        this.setState({
            emailErrorClass: this._checkEmailError() ? 'show' : 'hide',
            // firstNameErrorClass: (this._FirstNameInputRef.current && this._FirstNameInputRef.current.value.length === 0) ? 'show' : 'hide',
            // lastNameErrorClass: (this._LastNameInputRef.current && this._LastNameInputRef.current.value.length === 0) ? 'show' : 'hide',
        });
    }
    private _isEmailValid = (email: string): boolean => {
        const regex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return regex.test(email);
    };

    private _checkEmailError = (): boolean => {
        const email: string = this._EmailAddressInputRef.current && this._EmailAddressInputRef.current.value || '';
        if (email.length === 0) {
            return true;
        } else {
            return !this._isEmailValid(email);
        }
    }

    private _renderErrors = (): JSX.Element => {
        const {resources} = this.props;
        return (
            <>
                {/* <div className={this.state.firstNameErrorClass}>
                    {resources.firstNameError}
                </div>
                <div className={this.state.lastNameErrorClass}>
                    {resources.lastNameError}
                </div> */}
                <div className={this.state.emailErrorClass}>
                    {resources.emailError}
                </div>
                
            </>
        );
    }


    private _handleChange = (name: string) => (e: React.ChangeEvent<HTMLInputElement> | React.ChangeEvent<HTMLTextAreaElement>) => {
        const value = e.target.value;
        switch (name) {
            // case 'firstName': {
            //     this.setState({ firstName: value, fNError: false, reqError: false, eAValError: false});
            //     break;
            // }
            // case 'lastName': {
            //     this.setState({ lastName: value, lNError: false, reqError: false, eAValError: false});
            //     break;
            // }
            case 'emailAddress': {
                this.setState({ emailAddress: value, eAError: false, reqError: false, eAValError: false});
                break;
            }
            default: {
                console.log('No input box changes');
                this.setState({ reqError: false, eAValError: false});
            }
        }
    }

    private _handleSubmit(e: React.MouseEvent<HTMLElement> | React.KeyboardEvent<HTMLElement> | React.FormEvent<HTMLFormElement>) {
        this._recaptchaRef.current?.execute()
    }

    private async _submit(): Promise<void> {
        this._showErrors();
        
        // this.firstNameValue = (this._FirstNameInputRef && this._FirstNameInputRef.current && this._FirstNameInputRef.current.value) ? true : false;
        // this.lastNameValue = (this._LastNameInputRef && this._LastNameInputRef.current && this._LastNameInputRef.current.value) ? true : false;
        this.emailAddressValue = (this._EmailAddressInputRef && this._EmailAddressInputRef.current && this._EmailAddressInputRef.current.value) ? true : false;        

        // const fN = (this._FirstNameInputRef && this._FirstNameInputRef.current && this._FirstNameInputRef.current.value) ? this._FirstNameInputRef.current.value : '';
        // const lN = (this._LastNameInputRef && this._LastNameInputRef.current && this._LastNameInputRef.current.value) ? this._LastNameInputRef.current.value : '';
        const eA = (this._EmailAddressInputRef && this._EmailAddressInputRef.current && this._EmailAddressInputRef.current.value) ? this._EmailAddressInputRef.current.value : '';
        const eAVal = this._EmailAddressInputRef.current!.value;

        const recaptchaValue = this._recaptchaRef.current?.getValue();
        // console.log('recaptchaValue', recaptchaValue, this._recaptchaRef.current);

        // if (!this.firstNameValue) {
        //     this.setState({
        //         fNError: true,
        //         reqError: true
        //     });
        //     this._recaptchaRef.current?.reset();
        // } else if (!this.lastNameValue) {
        //     this.setState({
        //         lNError: true,
        //         reqError: true
        //     });
        //     this._recaptchaRef.current?.reset();
        //  } else if (!this.emailAddressValue) {
            if (!this.emailAddressValue) {
            this.setState({
                eAError: true,
                reqError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!this._isEmailValid(eAVal)) {
            this.setState({
                eAValError: true
            });
            this._recaptchaRef.current?.reset();
        } else if (!recaptchaValue) {
            this.setState({
                rCCError: true
            });
            this._recaptchaRef.current?.reset();
        } else {
            this.formInputValues = (this.emailAddressValue) ? true : false;
            if (this.formInputValues && !this.state.eAValError) {
                try {
                    // await this._postEntry(fN, lN, eA);
                    await this._postEntry(eA);

                    this._clearValues();
                    this._recaptchaRef.current?.reset();
                } catch (e) {
                    console.log(e, 'Please fill in the form!');
                }
            }
        }
    }


    // private async _postEntry(firstName: string, lastName: string, email: string): Promise<void> {
        private async _postEntry(email: string): Promise<void> {
        // NB in test the post body will need to look like this: { content: { emailAddress: email } }
        /* tslint:disable */

        let emarsysGroupId = this.props.config.emarsysGroupId;
       
        const response = await MsDyn365.commerceApiRequest(
            this.props.context.request,
            'PostPopUpCopy',
            'post',
            {
                // firstName: firstName,
                // lastName: lastName,
                emailAddress: email,
                country: this.props.config.country,
                emarsysGroupId: emarsysGroupId,
                optIn:true
            }
            
        ) as any;
        
        this.responseMessage = response?.data.Message;

        if (response?.data.Result !== 'Error') {
            this.setState({
                responseReceived: true,
                responseError: response?.data.Result === 'Error',
                responseSuccess: response?.data.Result !== 'Error',
                showResponseSuccess: true,
                emailAddress: '',
                // firstName: '',
                // lastName: '',
                reqError: false,
                eAValError: false,
                rCCError: false
            });

            setTimeout(this._setCookie, 1500)

        } else {
            this.setState({
                responseReceived: true,
                responseError: response?.data.Result === 'Error',
                responseSuccess: response?.data.Result !== 'Error',
                emailAddress: '',
                reqError: false,
                eAValError: false,
                rCCError: false
            });
        }
    }

    private _clearValues(): void {
        
        if (this._EmailAddressInputRef.current) {
            this._EmailAddressInputRef.current!.value = '';
        }
        // if (this._FirstNameInputRef.current) {
        //     this._FirstNameInputRef.current!.value = '';
        // }
        // if (this._LastNameInputRef.current) {
        //     this._LastNameInputRef.current!.value = '';
        // }
    }

    private _renderMessage(): React.ReactNode {
        return (
            <div className='popup-message-richtext'>
                <span dangerouslySetInnerHTML={getRichTextHtml(this.props.config.popoverMessage)} />
            </div>
        );
    }

    private checkCookie = () => {
        if(!this._timer) {
            this._timer = setInterval(()=> {
                const cookieValue = GetCookie(this.props.context.request.cookies, this._internationalCookieName);
                if (cookieValue === 'HIDE') {
                    this.setState({cookieValue: cookieValue })
                }
            }, 1000)
        }
    }

    private stopTimer = () => {
        clearInterval(this._timer);
    }

    private _renderCloseLink = () => {
        return (
            <Button
                className={`close-pop-up__button`}
                color='primary'
                onClick={() => this._setCookie()}
            >x</Button>
        )
    };

    private _setCookie = () => {
        const { config } = this.props;
        this.setState({cookieValue: 'HIDING'})
        SetCookie(this.props.context.request.cookies, 'HIDE', this._internationalCookieName, config.cookieAge || 2592000)
        setTimeout(() => {
            this.setState({cookieValue: 'HIDE'})
        }, 3000)
    }

    private _getViewport(): GridSize {
        const { context } = this.props;

        // always render in mobile viewport on a mobile device
        if (context.request && context.request.device && context.request.device.Type === 'Mobile') {
            return 'xs';
        }

        if (MsDyn365.msdyn365Commerce.isBrowser && window.innerWidth) {
            const gridSettings = context.request.gridSettings;
            if (gridSettings) {
                if (gridSettings.xs && window.innerWidth <= gridSettings.xs.w) {
                    return 'xs';
                } else if (gridSettings.sm && window.innerWidth <= gridSettings.sm.w) {
                    return 'sm';
                } else if (gridSettings.md && window.innerWidth <= gridSettings.md.w) {
                    return 'md';
                } else if (gridSettings.lg && window.innerWidth <= gridSettings.lg.w) {
                    return 'lg';
                } else {
                    return 'xl';
                }
            }
        }

        return 'lg';
    }

    private _updateViewport(): void {
        this._viewport = this._getViewport();
    }
}

export default CittaPopUpCopy;
